<template>
    <div v-if="search">

        <b-input-group size="lg">
            <b-input-group-prepend>
                <b-input-group-text>關鍵字</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input v-model="search.keyword" @keyup.enter="getProjects()"></b-form-input>
            <b-input-group-append>
                <b-button variant="success" @click="getProjects()">{{ $t('menu.search') }} {{ $t('menu.project') }}</b-button>
            </b-input-group-append>
        </b-input-group>


        <b-form-group label="專案狀態:">
            <b-form-checkbox-group v-model="search.types" >
                <b-form-checkbox v-for="type in search_settings.list_types" :key="type" :value="type">
                    {{ $t('status.project.' + type) }}
                </b-form-checkbox>
            </b-form-checkbox-group>
        </b-form-group>


        <div class="perpage-selector">
            <b-input-group>
                <b-input-group-prepend>
                    <b-input-group-text>{{ $t('menu.per_page') }}</b-input-group-text>
                </b-input-group-prepend>
                <b-select v-model="search.per_page" class="select-box">
                    <option v-for="(option, idx_option) in search_settings.page_options" :key="idx_option" :value="option.value" class="select-item">
                        {{ option.text }}
                    </option>
                </b-select>
            </b-input-group>
        </div>

        <div class="sort-selector">
            <b-input-group>
                <b-input-group-prepend>
                    <b-input-group-text>{{ $t('menu.order_by') }}</b-input-group-text>
                </b-input-group-prepend>
                <b-select v-model="search.sort" class="select-box">
                    <option v-for="(option, idx_option) in search_settings.list_sort" :key="idx_option" :value="option.value" class="select-item">
                        {{ option.text }}
                    </option>
                </b-select>
            </b-input-group>
        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: {
        search_on_show: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            search: undefined,
        }
    },
    mounted ()
    {
        this.search = {
            sort:           this.search_settings.sort,
            per_page:       this.search_settings.per_page,
            current_page:   this.search_settings.current_page,
            keyword: this.search_settings.keyword,
            types:   this.search_settings.types,
            // data_count:     this.search_settings.data_count,
        }

        if ( this.search_on_show == true )
        {
            this.getProjects()
        }
    },
    computed: {
        ...mapState({
            'search_settings': state => state.project.search_settings,
        }),
    },
    watch: {
        'search_settings.sort'          () { this.update_search() },
        'search_settings.per_page'      () { this.update_search() },
        'search_settings.current_page'  () { this.update_search() },
        'search_settings.keyword'       () { this.update_search() },
        'search_settings.types'         () { this.update_search() },
    },
    methods: {

        update_search ()
        {
            this.search = {
                sort:           this.search_settings.sort,
                per_page:       this.search_settings.per_page,
                current_page:   this.search_settings.current_page,
                keyword:        this.search_settings.keyword,
                types:          this.search_settings.types,
            }
        },

        getProjects: function ()
        {

            this.$store.dispatch('project/getProjects', this.search)
                .then(res => {})
                .catch(err => {})
        },

    },
}
</script>

<style lang="scss" scoped>

.perpage-selector
{
    display: inline-block;
    width: 100%;
    max-width: 180px;
    margin-right: 20px;
}

.sort-selector
{
    display: inline-block;
    width: 100%;
    max-width: 280px;
    margin-right: 20px;
}

</style>
